<div class="map-wrapper">
  <div class="map-container" #mapContainer>
    <!-- SVG Map-->
  </div>
  <div
    *ngFor="let tooltip of tooltips"
    class="tooltip"
    [style.left.px]="tooltip.x"
    [style.top.px]="tooltip.y"
  >
    {{ tooltip.content }}
  </div>
</div>
